export default function VacancyCandidate({ match, vacancyCandidate, onOpen }) {
  const candidate = vacancyCandidate.candidate;

  // 强制将挡逻辑应该放在后端，River加的
  // 检查硬性短板，强制降档
  const hasCriticalGap = vacancyCandidate.match_details?.key_concerns?.some(
    (concern) =>
      concern.includes("缺乏内容创作能力") ||
      concern.includes("缺乏新媒体运营经验") ||
      concern.includes("缺乏核心技术技能") ||
      concern.includes("缺乏管理经验"),
  );

  if (hasCriticalGap) {
    vacancyCandidate.match_score = 59; // 强制降档
  }

  // 这个也放在后端
  const getLevelLabel = (score) => {
    if (score >= 85) return "顶尖匹配";
    if (score >= 81) return "优秀候选";
    if (score >= 75) return "值得考虑";
    if (score >= 60) return "可尝试";
    return "不太匹配";
  };

  return (
    <div
      className="bg-white rounded-2xl shadow p-8 flex flex-col gap-6 border border-gray-200 max-w-4xl w-full mx-auto transition hover:shadow-lg hover:scale-[1.01] duration-200"
      style={{
        fontFamily:
          "-apple-system,BlinkMacSystemFont,'San Francisco','PingFang SC','Segoe UI',Arial,sans-serif",
      }}
    >
      {/* 概览区 */}
      <div className="flex items-center gap-6">
        <div className="w-20 h-20 rounded-xl bg-gray-100 flex items-center justify-center text-3xl font-bold text-gray-900 shadow-inner">
          {vacancyCandidate.match_score}
        </div>
        <div className="flex-1">
          <div className="text-2xl font-bold text-gray-900">{candidate.name}</div>
          <div className="text-base text-gray-500 mt-1">
            {candidate.title} · {candidate.total_years_experience}年 ·{" "}
            {candidate.education || "学历未知"}
          </div>
        </div>
        <div>
          <span className="px-4 py-1 rounded-full text-sm font-semibold bg-gray-100 text-gray-900 border border-gray-200">
            {getLevelLabel(vacancyCandidate.match_score)}
          </span>
        </div>
      </div>
      {/* 分隔线 */}
      <div className="border-t border-gray-100" />
      {/* AI摘要 */}
      {vacancyCandidate.match_details?.summary && (
        <div className="flex items-center bg-gray-50 rounded px-4 py-3 text-base font-medium text-gray-900">
          <span className="font-semibold mr-2">AI摘要</span>
          <span>{vacancyCandidate.match_details.summary}</span>
        </div>
      )}
      {/* 分隔线 */}
      <div className="border-t border-gray-100" />
      {/* 标签区：只展示亮点 */}
      <div className="flex flex-wrap gap-3">
        {vacancyCandidate.match_details?.key_strengths?.map((s, i) => (
          <span
            key={i}
            className="bg-gray-50 border border-blue-200 text-blue-700 px-3 py-1 rounded-full text-xs font-medium"
          >
            {s}
          </span>
        ))}
      </div>
      {/* 详细区（可折叠，展示缺点） */}
      <details className="bg-gray-50 rounded p-4">
        <summary className="cursor-pointer text-base font-semibold text-gray-900">
          详细评估
        </summary>
        <div className="mt-3 space-y-4">
          <div>
            <div className="font-semibold text-gray-900 mb-1 flex items-center gap-2">
              <span>关键优势</span>
            </div>
            <ul className="list-disc list-inside text-base text-gray-900 pl-4">
              {vacancyCandidate.match_details?.keyStrengths?.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-semibold text-gray-900 mb-1 flex items-center gap-2">
              <span>主要风险</span>
            </div>
            <ul className="list-disc list-inside text-base text-gray-900 pl-4">
              {vacancyCandidate.match_details?.keyConcerns?.map((c, i) => (
                <li key={i}>{c}</li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-semibold text-gray-900 mb-1 flex items-center gap-2">
              <span>面试建议</span>
            </div>
            <ul className="list-disc list-inside text-base text-gray-900 pl-4">
              {vacancyCandidate.match_details?.interviewFocusAreas?.map((a, i) => (
                <li key={i}>{a}</li>
              ))}
            </ul>
          </div>
        </div>
      </details>
      {/* 操作区 */}
      <div className="flex justify-end mt-2">
        <button
          onClick={() => onOpen(candidate)}
          className="border border-blue-600 text-blue-700 bg-white hover:bg-blue-600 hover:text-white rounded-lg px-6 py-2 text-base font-semibold transition"
        >
          查看完整简历
        </button>
      </div>
    </div>
  );
}
